(()=>{
function init(root){
 root.querySelectorAll('[data-scrc]').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  const cards=[...section.querySelectorAll('[data-scrc-card]')];
  cards.forEach((card,index)=>{
   card.dataset.order=index;
   const variants=JSON.parse(card.querySelector('[data-scrc-variants]').textContent);
   let size=section.dataset.mode==='kg'?'1kg':'250g';
   const grind=card.querySelector('[data-scrc-grind]');
   const update=()=>{
    const v=variants.find(v=>v.size===size&&v.grind===(grind?.value||'WHOLE BEAN'));
    const cta=card.querySelector('[data-scrc-cta]'),photo=card.querySelector('[data-scrc-photo]');
    if(!v||!v.available){cta.removeAttribute('href');cta.setAttribute('aria-disabled','true');cta.textContent=card.dataset.unavailable;photo.href=card.dataset.url;}
    else{const url=card.dataset.url+'?variant='+v.id;cta.href=url;photo.href=url;cta.removeAttribute('aria-disabled');cta.textContent=card.dataset.choose+' '+card.dataset.title;}
    card.querySelector('[data-scrc-price]').innerHTML=v?v.money:card.dataset.unavailable;
    card.querySelector('[data-scrc-size-label]').textContent=size+' · '+card.dataset.purchase;
    card.querySelector('[data-scrc-equivalent]').innerHTML=v&&size==='1kg'?v.equivalent+' '+card.dataset.equivalent:'';
    card.dataset.price=v?.price||0;
   };
   card.querySelectorAll('[data-scrc-size]').forEach(b=>b.addEventListener('click',()=>{size=b.dataset.scrcSize;card.querySelectorAll('[data-scrc-size]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));update();}));
   grind?.addEventListener('change',update);update();
  });
  section.querySelector('[data-scrc-sort]')?.addEventListener('change',e=>{
   const mode=e.target.value;
   [...cards].sort((a,b)=>mode==='price-asc'?+a.dataset.price-+b.dataset.price:mode==='price-desc'?+b.dataset.price-+a.dataset.price:mode==='title'?a.dataset.title.localeCompare(b.dataset.title):+a.dataset.order-+b.dataset.order).forEach(c=>section.querySelector('.scrc-grid').append(c));
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
